import styled from 'styled-components';

const LeaderboardItemName = styled.h4``;

export default LeaderboardItemName;
